// jshint -W030
(function ($, psw, _kmq) {
    'use strict';

    cookieConsent.analyticsEnabled && $(function() {
        $('.get-started-cta').click(function (e) {
            e.preventDefault();
            _kmq && _kmq.push(['record', 'Clicked Get Started in NServiceBus page']);
            trackOutboundLink(this, 'Clicked Get-Started CTA (NSB Page Bottom)');
        });
    });

    $(function () {

        var $scenario = $('#scenario-selection');
        var $tech = $('#technology-selection');
        var $barebonesCode = $('#barebones-code');
        var $nsbCode = $('#with-nservicebus-code');

        var updateBlock = function ($el, type, scenario, tech) {
            var path = '/code/nservicebus/' + type + '/' + tech + '/' + scenario + '.txt';
            $.get(path, function (codeText) {
                $el.empty();
                var $newCode = $('<code class="language-csharp"></code>');
                $newCode.text(codeText);
                $newCode.appendTo($el);

                hljs.highlightBlock($newCode[0]);
            });
        };

        var updateScenarios = function() {
            var scenario = $scenario.find(':selected').val();
            var tech = $tech.find(':selected').val();

            updateBlock($barebonesCode, 'barebones', scenario, tech);
            updateBlock($nsbCode, 'with-nsb', scenario, tech);
        };

        $scenario.change(updateScenarios);
        $tech.change(updateScenarios);
        updateScenarios();
    });

}(jQuery, window.psw, window._kmq));
